import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatName'
})
export class FormatName implements PipeTransform {
    transform(value: string, args: any[]): string {
        if (!value)
            return value;

        const nameParts = value.split(' ');

        return nameParts.length == 1 ? nameParts[0] : `${nameParts[0]} ${nameParts[nameParts.length - 1]}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/format-name.pipe.ts